export default {
    getPaymentGeneratedLink(state) {
        return state.paymentGeneratedLink;
    }
}
